/*
 * vrtPSHTF.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSHTF: RouteRecordRaw = {
  path: '/powersteer/htf',
  name: 'vrtPSHTF',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // TRAINER WEEKEND DUTY ROSTER
    {
      path: 'trainer/weekend/duty/roster/list',
      name: 'vrtPSHTFTrainerWeekendDutyRosterList',
      component: () => import('./vpgPSHTFTrainerWeekendDutyRosterList.vue'),
    },
    {
      path: 'trainer/weekend/duty/roster/operate',
      name: 'vrtPSHTFTrainerWeekendDutyRosterOperate',
      component: () => import('./vpgPSHTFTrainerWeekendDutyRosterOperate.vue'),
    },
    {
      path: 'trainer/weekend/duty/roster/view',
      name: 'vrtPSHTFTrainerWeekendDutyRosterView',
      component: () => import('./vpgPSHTFTrainerWeekendDutyRosterView.vue'),
    },
    {
      path: 'trainer/weekend/duty/roster/view/details',
      name: 'vrtPSHTFTrainerWeekendDutyRosterViewDetails',
      component: () => import('./vpgPSHTFTrainerWeekendDutyRosterViewDetails.vue'),
    },
    {
      path: 'trainer/my/weekend/duty/list',
      name: 'vrtPSHTFTrainerMyWeekendDutyList',
      component: () => import('./vpgPSHTFTrainerMyWeekendDutyList.vue'),
    },
  ],
};
//
export default vrtPSHTF;
//#end#
